/**
 * @description 車險、行動、住火投保規則 ID
*/
export enum ProdLimitId {
    CARLMT = 'CARLMT',
    MOTORLMT = 'MOTORLMT',
    CARBODY = 'CARBODY',
    MOBDEVLMT = 'MOBDEVLMT',
    MOBDEVMAINLMT = 'MOBDEVMAINLMT',
    FRBCLMT ='FRBCLMT',
    FRPRODLMT = 'FRPRODLMT'
}
